const I = (id, name, price, desc, cat, best = false) => ({ id, name, price, desc, cat, best });

export const ORDER_ITEMS = [
  // Dim Sum
  I("umami-cloud-dimsum", "Umami Cloud Dimsum", 210, "Shiitake mushroom, cheese, broccoli, zucchini & sesame oil in a delicate pleat.", "dimsum", true),
  I("spincorn-cheese-dimsum", "Spincorn Cheese Dimsum", 249, "Spinach, corn and cheese steamed into soft green clouds.", "dimsum"),
  I("mushroom-cream-cheese-dimsum", "Mushroom Cream Cheese Dimsum", 249, "Button mushroom and molten cream cheese with flavoured dips.", "dimsum"),
  I("crispy-mushroom-gyoza", "Crispy Mushroom Gyoza", 220, "Japanese-style crisp base dumplings filled with mushroom.", "dimsum"),
  I("crystal-garden-dumplings", "Crystal Garden Dumplings", 249, "Garden-fresh vegetables in a translucent silky skin.", "dimsum"),
  // Sushi
  I("spicy-shiitake-roll", "Spicy Shiitake Mushroom Roll", 349, "Bold heat wrapped in umami indulgence.", "sushi", true),
  I("avocado-cream-cheese-roll", "Avocado Cream Cheese Roll", 369, "Creamy avocado balanced with smooth, rich melt-in-every-bite bliss.", "sushi"),
  I("california-roll", "California Roll", 349, "Avocado, cucumber and carrot — the timeless classic.", "sushi"),
  I("cream-cheese-sesame-roll", "Cream Cheese Sesame Roll", 349, "Classic, fresh and effortlessly satisfying.", "sushi"),
  // Bao
  I("thai-bao", "Thai Bao", 249, "Pillowy steamed bao packed with wok-tossed tofu and fragrant Thai herbs.", "bao", true),
  I("chilli-paneer-bao", "Chilli Paneer Bao", 269, "Soft bun hugging spicy chilli paneer.", "bao"),
  I("mushroom-bao", "Mushroom Bao", 249, "Steamed bun loaded with glazed mushrooms.", "bao"),
  // Dum Biryani
  I("hyderabadi-veg-biryani", "Hyderabadi Veg Biryani", 299, "Bold and spicy, slow-cooked on dum with saffron, mint and fried onions.", "biryani", true),
  I("kolkata-veg-biryani", "Kolkata Veg Biryani", 279, "The gentle, aromatic classic with potato and whole spices.", "biryani"),
  I("lucknowi-veg-biryani", "Lucknowi Veg Biryani", 279, "Awadhi-style fragrant layers, subtle and royal.", "biryani"),
  I("paneer-biryani", "Paneer Biryani", 299, "Marinated paneer nestled in aromatic basmati.", "biryani"),
  I("mushroom-biryani", "Mushroom Biryani", 299, "Earthy mushrooms layered with spice and saffron.", "biryani"),
  I("bloomora-special-biryani", "Bloomora Special Biryani", 319, "The chef's guarded recipe — our blooming pride.", "biryani", true),
  // Main Course
  I("paneer-butter-masala", "Paneer Butter Masala", 319, "Paneer cubes in a creamy onion-tomato cashew gravy.", "main", true),
  I("palak-paneer", "Palak Paneer", 319, "Cubes of paneer folded into creamy palak gravy.", "main"),
  I("kadhai-paneer", "Kadhai Paneer", 319, "Tossed with sautéed onion, capsicum and tomato masala.", "main"),
  I("paneer-korma", "Paneer Korma", 359, "Succulent paneer in a rich, nutty korma gravy.", "main"),
  I("malai-kofta", "Malai Kofta", 319, "Melt-in-mouth paneer-potato dumplings in velvety cashew-tomato gravy.", "main"),
  I("matar-paneer", "Matar Paneer", 299, "Cottage cheese and green peas in a classic spiced onion-tomato gravy.", "main"),
  I("mushroom-masala", "Mushroom Masala", 319, "Fresh button mushrooms in a bold, semi-dry masala.", "main"),
  I("kaju-malai-methi", "Kaju Malai Methi", 359, "Whole cashews and fresh fenugreek in a luscious cashew-cream gravy.", "main"),
  I("smoked-dal-makhani", "Smoked Dal Makhani", 259, "Lentils cooked in a smoky, buttery makhani gravy.", "main"),
  I("chole-masala", "Chole Masala", 259, "Spicy and tangy white chickpea curry with aromatic spices.", "main"),
  // Breads
  I("tandoori-roti", "Tandoori Roti (Butter)", 40, "Whole-wheat, puffed over live coals.", "breads"),
  I("butter-naan", "Butter Naan", 60, "Pillow-soft naan glossed with butter.", "breads"),
  I("garlic-naan", "Garlic Naan", 70, "Flecked with garlic and fresh coriander.", "breads"),
  I("laccha-paratha", "Laccha Paratha", 59, "Sixteen flaky layers, crisp at the edges.", "breads"),
  I("paneer-kulcha", "Paneer Kulcha", 90, "Stuffed with spiced paneer, griddled golden.", "breads"),
  I("cheese-garlic-toast", "Cheese Garlic Toast", 210, "Garlic butter bread toast loaded with cheese.", "breads"),
  I("veg-grilled-cheese-corn", "Veg Grilled Cheese & Corn Sandwich", 129, "Sweet juicy corn with veggies and a creamy touch.", "breads"),
  I("veg-grilled-cheese-paneer", "Veg Grilled Cheese & Paneer Sandwich", 149, "Crumbled paneer tossed with peri-peri and mozzarella.", "breads"),
  // South Indian
  I("masala-dosa", "Masala Dosa", 140, "Spiced potato folded in a golden crisp crepe.", "south", true),
  I("plain-dosa", "Plain Dosa", 110, "Paper-crisp, ghee-kissed, timeless.", "south"),
  I("mysore-dosa", "Mysore Dosa", 160, "A fiery red chutney under the masala.", "south"),
  I("ghee-roast-dosa", "Ghee Roast Dosa", 180, "Slow-roasted in ghee till deeply golden.", "south"),
  I("cheese-masala-dosa", "Cheese Masala Dosa", 190, "Molten cheese over the classic masala.", "south"),
  I("bloomora-special-dosa", "Bloomora Special Dosa", 240, "Our signature crisp — loaded edge to edge.", "south"),
  I("plain-idli", "Plain Idli", 80, "Steamed rice clouds with warm sambar.", "south"),
  I("sambar-vada", "Sambar Vada", 110, "Crisp vada soaked in hot sambar.", "south"),
  I("masala-uttapam", "Masala Uttapam", 170, "Thick, soft and jewelled with spiced masala.", "south"),
  // Pizza & Pasta
  I("margherita-pizza", "Classic Margherita Pizza", 319, "Cheesy all-time favourite topped with basil and cherry tomato. (Medium)", "pizza"),
  I("farm-fresh-veg-pizza", "Chargrilled Farm Fresh Veg Pizza", 329, "Smoky char-grilled garden vegetables over bubbling cheese. (Medium)", "pizza"),
  I("spicy-cottage-cheese-pizza", "Spicy Cottage Cheese Pizza", 339, "Paneer with a gentle heat on a golden crust. (Medium)", "pizza"),
  I("smoked-paneer-mushroom-pizza", "Smoked Paneer & Mushroom Pizza", 359, "Smoky paneer and mushroom over rich tomato sauce. (Medium)", "pizza"),
  I("alfredo-pasta", "Alfredo Pasta", 329, "Penne/spaghetti tossed with mushrooms in a creamy garlic cheese sauce.", "pizza"),
  I("arrabiata-pasta", "Arrabiata Pasta", 329, "A bold, spicy red-sauce classic.", "pizza"),
  I("aglio-olio-pasta", "Aglio e Olio Pasta", 329, "Garlic, olive oil and chilli flakes — simply perfect.", "pizza"),
  // Waffles & Shakes
  I("biscoff-waffle", "Biscoff Waffle", 245, "Crispy golden waffle with imported Lotus Biscoff spread.", "waffles", true),
  I("belgian-triple-chocolate-waffle", "Belgian Triple Chocolate Waffle", 205, "Topped with Belgian milk, white and dark chocolate.", "waffles"),
  I("blueberry-cheesecake-waffle", "Blueberry Cheesecake Waffle", 235, "Waffle-wich with sweetened cream cheese and blueberry.", "waffles"),
  I("nutella-cheesecake-waffle", "Nutella Cheesecake Waffle", 235, "Nutella meets cream cheese in a warm waffle.", "waffles"),
  I("kitkat-waffle", "KitKat Waffle", 205, "Crunchy KitKat over a golden waffle.", "waffles"),
  I("butterscotch-shake", "Butterscotch Shake", 129, "Thick, creamy and caramel-kissed.", "waffles", true),
  I("chocolate-shake", "Chocolate Shake", 129, "Classic rich chocolate, blended thick.", "waffles"),
  I("oreo-shake", "Oreo Shake", 139, "Cookies and cream in a tall glass.", "waffles"),
  I("kitkat-shake", "KitKat Shake", 149, "Chocolate wafer crunch in every sip.", "waffles"),
  I("dry-fruit-shake", "Dry Fruit Shake", 169, "Loaded with almonds, cashews and dates.", "waffles"),
  I("vanilla-shake", "Vanilla Shake", 119, "Smooth, simple and sweet.", "waffles"),
  I("nutella-milkshake", "Nutella Milkshake", 159, "Hazelnut-chocolate indulgence.", "waffles"),
  I("strawberry-shake", "Strawberry Shake", 129, "Fresh strawberry blush in a glass.", "waffles"),
  I("hot-coffee", "Hot Coffee", 60, "Freshly brewed, warm and comforting.", "waffles", true),
  I("cold-coffee", "Cold Coffee", 139, "Chilled, frothy and bold.", "waffles"),
  I("cold-coffee-icecream", "Cold Coffee with Ice Cream", 169, "Cold coffee crowned with a vanilla scoop.", "waffles"),
];

const U = (id) => `https://images.unsplash.com/photo-${id}?auto=format&fit=crop&w=400&q=80`;

const CAT_IMAGES = {
  dimsum: [U("1496116218417-1a781b1c416c"), U("1563245372-f21724e3856d")],
  sushi: [U("1579871494447-9811cf80d66c"), U("1553621042-f6e147245754")],
  bao: [U("1563245372-f21724e3856d"), U("1496116218417-1a781b1c416c")],
  biryani: [U("1589302168068-964664d93dc0"), U("1563379091339-03b21ab4a4f8")],
  main: [U("1585937421612-70a008356fbe"), U("1631452180519-c014fe946bc7"), U("1565557623262-b51c2513a641")],
  breads: [U("1565557623262-b51c2513a641"), U("1528735602780-2552fd46c7af")],
  south: [U("1630383249896-424e482df921"), U("1589301760014-d929f3979dbc")],
  pizza: [U("1513104890138-7c749659a591"), U("1565299624946-b28f40a0ae38")],
  waffles: [U("1562376552-0d160a2f238d"), U("1572490122747-3968b75cc699")],
};

const IMG_OVERRIDES = {
  "veg-grilled-cheese-corn": U("1528735602780-2552fd46c7af"),
  "veg-grilled-cheese-paneer": U("1528735602780-2552fd46c7af"),
  "plain-idli": U("1589301760014-d929f3979dbc"),
  "sambar-vada": U("1589301760014-d929f3979dbc"),
  "alfredo-pasta": U("1621996346565-e3dbc646d9a9"),
  "arrabiata-pasta": U("1473093295043-cdd812d0e601"),
  "aglio-olio-pasta": U("1621996346565-e3dbc646d9a9"),
  "butterscotch-shake": U("1572490122747-3968b75cc699"),
  "chocolate-shake": U("1572490122747-3968b75cc699"),
  "oreo-shake": U("1572490122747-3968b75cc699"),
  "kitkat-shake": U("1572490122747-3968b75cc699"),
  "dry-fruit-shake": U("1572490122747-3968b75cc699"),
  "vanilla-shake": U("1572490122747-3968b75cc699"),
  "nutella-milkshake": U("1572490122747-3968b75cc699"),
  "strawberry-shake": U("1572490122747-3968b75cc699"),
  "hot-coffee": U("1509042239860-f550ce710b93"),
  "cold-coffee": U("1461023058943-07fcbe16d735"),
  "cold-coffee-icecream": U("1461023058943-07fcbe16d735"),
};

const poolCounters = {};
ORDER_ITEMS.forEach((item) => {
  if (IMG_OVERRIDES[item.id]) {
    item.img = IMG_OVERRIDES[item.id];
    return;
  }
  const pool = CAT_IMAGES[item.cat] || CAT_IMAGES.main;
  const i = poolCounters[item.cat] || 0;
  poolCounters[item.cat] = i + 1;
  item.img = pool[i % pool.length];
});

export const ORDER_CATEGORIES = [
  { id: "best", name: "Bestsellers" },
  { id: "dimsum", name: "Dim Sum" },
  { id: "sushi", name: "Sushi" },
  { id: "bao", name: "Bao" },
  { id: "biryani", name: "Dum Biryani" },
  { id: "main", name: "Main Course" },
  { id: "breads", name: "Breads" },
  { id: "south", name: "South Indian" },
  { id: "pizza", name: "Pizza & Pasta" },
  { id: "waffles", name: "Waffles & Shakes" },
];

export const itemsForCategory = (catId) =>
  ORDER_ITEMS.filter((i) => (catId === "best" ? i.best : i.cat === catId));
